import {
  Annotation,
  Axis,
  Chart,
  Coordinate,
  G2,
  Geom,
  Interval,
  Legend,
  Line,
  Point,
  Tooltip,
} from 'bizcharts';
import { IEvent } from 'bizcharts/lib/interface';
import { ChartByCustomerGroupDataType } from '../../api/apiConfig';
import { useMonthlyGroupedResultChart } from './provider/MonthlyGroupedResultChartProvider';

export const ChartByCustomerGroup = () => {
  const { data } = useMonthlyGroupedResultChart();
  let chartIns: G2.Chart | null = null;
  const scale = {
    orderCount: {
      min: 0,
      tickCount: 4,
      alias: '주문건수',
      type: 'linear-strict',
      formatter: (d: number) => `${d.toLocaleString()}회`, // 금액 포맷팅 (1000 단위 쉼표 추가 및 '원' 추가)
    },
    orderAmount: {
      min: 0,
      tickCount: 5,
      alias: '주문총액',
      type: 'linear-strict',
      formatter: (d: number) => `${d.toLocaleString()}원`, // 금액 포맷팅 (1000 단위 쉼표 추가 및 '원' 추가)
    },
    month: {
      formatter: (d: string) => `${d}월`, // 금액 포맷팅 (1000 단위 쉼표 추가 및 '원' 추가)
    },
  };

  const colors = ['#699bff', '#fd6666'];

  return (
    data.length > 0 && (
      <div>
        <div style={{ height: '20px' }} />
        <Chart
          height={380}
          data={data}
          scale={scale}
          autoFit
          // padding={[40, 80, 50, 125]}
          onAxisLabelClick={console.log}
        >
          <Legend
            position='right'
            itemName={{
              style: (item) => {
                return { fill: item.name == 'Tokyo' ? colors[0] : colors[1] };
              },
            }}
          />
          <Axis name='month' />
          {/* <Axis
            name='temperature'
            label={{
              formatter: (val) => `${val}°C`,
            }}
          /> */}

          <Geom
            type='point'
            position='month*orderAmount'
            size={4}
            shape={'circle'}
            color={'customerGroup'}
            style={{
              stroke: '#fff',
              lineWidth: 1,
            }}
          />
          <Geom
            type='line'
            position='month*orderAmount'
            size={2}
            color={'customerGroup'}
            //   shape={'smooth'}
          />
        </Chart>
      </div>
    )
  );
};
